import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Device } from '../../domain/cloud-topology';
import { HttpClient } from '@angular/common/http';
import { AuthGuardService } from '../auth-guard.service';
import { ResourceService } from '../resource.service';
import {environment} from "../../../environments/environment";
import {batteriesUrl, devicesUrl} from "../../domain/constants";
import {map} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class SiteDeviceService {

  constructor(private http: HttpClient) { }

  getBatterySystems(): Observable<string[]> {

    return this.http.get(ResourceService.buildUrl([environment.topologyUrl, batteriesUrl])).pipe(map(res => res['data']));
  }

  getDevices(siteId: string): Observable<Device[]> {

    return this.http.get(ResourceService.buildUrl([environment.topologyUrl, devicesUrl, siteId])).pipe(map(res => res['data']));
  }

  putDevices(siteId: string, devices: any): Observable<Device[]> {

    return this.http.put(ResourceService.buildUrl([environment.topologyUrl, devicesUrl, siteId]), devices).pipe(map(res => res['data']));
  }

  postDevices(siteId: string, devices: Device[]): Observable<any> {

    return this.http.post(ResourceService.buildUrl([environment.topologyUrl, devicesUrl, siteId]), devices).pipe(map(res => res['data']));
  }

  deleteDevice(deviceId: string): Observable<any> {
    return this.http.delete(ResourceService.buildUrl([environment.topologyUrl, devicesUrl, deviceId])).pipe(map(res => res['data']));
  }
}
